module.exports = __webpack_public_path__ + "img/Jose-Manuel-Martinez.aa207993.png";